"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.stringify.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _vuexModuleDecorators = require("vuex-module-decorators");
var _products = require("@/api/products");
var _utils = require("@/utils");
var _index = _interopRequireDefault(require("@/components/HelpText/index.vue"));
var _attributes = require("@/api/attributes");
var _index2 = _interopRequireDefault(require("@/components/FileUpload/index.vue"));
var _taxes = require("@/api/master/taxes");
var _licenseTc = require("@/api/master/licenseTc");
var _tinymceVue = _interopRequireDefault(require("@tinymce/tinymce-vue"));
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.loading = false;
    this.rules = {};
    this.attributesAndValues = [];
    this.productsVariations = [];
    this.showDelete = false;
    this.previousPriceUpdatedFlag = false;
    this.bulkStepper = 10;
    this.activeCollapseIndex = 0;
    this.isDefaultAttribute = true;
    this.tax = null;
    this.licneseTcsList = [];
  }
  submitForm() {
    if (this.productsVariations && this.productsVariations.length) {
      for (const variation of this.productsVariations) {
        if (variation.salePrice === undefined || variation.salePrice === null || +variation.salePrice <= 0) {
          this.$message.error(`Sale Price is required for variation "${variation.modelCode || variation.name || ''}"!`);
          return false;
        }
      }
    }
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  async activated() {
    this.getLicenseTcsList();
    if (this.formData.taxId) {
      this.tax = await (0, _taxes.getTaxById)(this.formData.taxId);
    }
    // set to products variations
    this.productsVariations = this.formData.productsVariation;
    if (this.productsVariations && this.productsVariations.length) {
      this.productsVariations.sort(function (a, b) {
        return a.id - b.id;
      });
      // Extract the IDs from the object array to bind to the select
      this.productsVariations.forEach(variation => {
        let mappedIds = [];
        if (variation.licenseTc && Array.isArray(variation.licenseTc)) {
          // Transforms [{id: 1, name: '...'}] into [1]
          mappedIds = variation.licenseTc.map(tc => tc.id);
        }
        // CRITICAL: Use $set so Vue tracks this new property for the dropdown
        this.$set(variation, 'licenseTcId', mappedIds);
      });
    }
    this.getAttributesAndValues();
  }
  updateVariationName(index) {
    const variation = this.formData.productsVariation[index];
    variation.name = variation.modelCode || '';
  }
  handleProductTypeChange() {
    this.$emit('updated', this.formData);
  }
  handleAttribute(attributesValueId, attributeId, index) {
    this.attributesAndValues[index].selectedValueId = attributesValueId;
  }
  async getAttributesAndValues() {
    try {
      if (this.formData.attribute && this.formData.attribute.length > 0) {
        const selectedAttributeIds = this.formData.attribute.filter(attribute => attribute).map(attribute => attribute.id);
        const attributes = await (0, _attributes.getAttributesTree)({
          attributes: JSON.stringify(selectedAttributeIds)
        });
        attributes.forEach(attr => {
          attr.selectedValueId = null;
        });
        this.attributesAndValues = attributes;
      }
    } catch (err) {
      console.error(err);
    }
  }
  async saveForm() {
    this.loading = true;
    try {
      this.productsVariations.forEach(variation => {
        variation.name = variation.modelCode;
      });
      const variation = await (0, _products.updateProductVariations)(this.productsVariations);
      this.productsVariations = variation;
      this.$notify({
        title: 'Success',
        message: 'Variations saved',
        type: 'success',
        duration: 2000
      });
      this.$emit('added', true);
      this.$emit('reload', {});
    } catch (err) {
      this.$notify.error({
        title: 'Failed to save',
        message: err + ''
      });
    } finally {
      this.loading = false;
    }
  }
  fileUploaded(file) {}
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async getLicenseTcsList() {
    try {
      const data = await (0, _licenseTc.getLicenseTcs)((0, _utils.getQuery)({
        page: 1,
        limit: 1000,
        sort: 'id,ASC'
      }));
      this.licneseTcsList = data.data.filter(tc => tc.enabled);
    } catch (error) {
      console.error('Failed to fetch License TCs', error);
    }
  }
  addVariation() {
    const productId = this.formData.id;
    const attributesAndValues = [];
    this.attributesAndValues.forEach(attributeValue => {
      if (attributeValue.selectedValueId) {
        attributesAndValues.push({
          productId: productId,
          attributeId: attributeValue.id,
          attributesValueId: attributeValue.selectedValueId
        });
      }
    });
    if (attributesAndValues.length !== this.attributesAndValues.length) {
      this.$message({
        type: 'error',
        message: 'Select attributes'
      });
      return;
    }
    const addedIndex = this.productsVariations.push({
      id: null,
      enabled: true,
      name: '',
      productId: productId,
      productsVariationsAttribute: attributesAndValues,
      modelCode: '',
      sku: '',
      salePrice: 0,
      description: '',
      manageStock: this.formData.manageStock,
      stockStatus: this.formData.stockStatus,
      stockQuantity: 0
    }) - 1;
    this.productsVariations[addedIndex].name = this.getVariationTitle(addedIndex);
  }
  getVariationTitle(index) {
    const variationAttributesValueIds = this.productsVariations[index].productsVariationsAttribute.map(variationAttributesValue => variationAttributesValue.attributesValueId);
    const title = [];
    this.attributesAndValues.forEach(attribute => {
      attribute.attributesValues.forEach(attributesValue => {
        if (variationAttributesValueIds.indexOf(attributesValue.id) > -1) {
          title.push(attributesValue.name);
        }
      });
    });
    return title.join(' ');
  }
  editName(event, index) {
    event.preventDefault();
    this.productsVariations[index].edit = true;
  }
  saveName(event, index) {
    event.preventDefault();
    this.productsVariations[index].edit = false;
  }
  async handleDelete(event, index) {
    event.preventDefault();
    event.stopPropagation();
    const variation = this.productsVariations[index];
    try {
      await this.$confirm('Are you sure you want to delete this variation?', 'Delete', {
        confirmButtonText: 'Delete',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: 'Cancel',
        type: 'error'
      });
      if (variation.id) {
        await (0, _products.deleteProductVariation)(variation.id);
      }
      this.productsVariations.splice(index, 1);
    } catch (error) {
      this.$message({
        type: 'info',
        message: 'Delete canceled'
      });
    }
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: {}
})], default_1.prototype, "formData", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], default_1.prototype, "saveForm", null);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'ProductVariationTab',
  components: {
    HelpText: _index.default,
    FileUpload: _index2.default,
    Editor: _tinymceVue.default
  }
})], default_1);
var _default = exports.default = default_1;